import type { InputLog } from "../../../types/inputs";
import { getLogSeverityClassName } from "../../../utils/inputsOrbits";

export const InputOrbitLogCard = ({ log }: { log: InputLog }) => {
  return (
    <article className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
      <header className="flex flex-wrap items-center gap-2">
        <span
          className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${getLogSeverityClassName(
            log.severity,
          )}`}
        >
          {log.severity}
        </span>

        <span className="text-xs font-medium text-slate-500">
          {log.timestamp}
        </span>

        <span className="text-xs text-slate-400">&bull;</span>
      </header>

      <p className="mt-2 whitespace-pre-wrap text-sm text-slate-800">
        {log.message}
      </p>
    </article>
  );
};
